<template>
    <div class="root">
        <svg width="20" height="20" viewBox="0 0 20 20">
            <path d="M12.9 14.32c-1.34 1.049-3.050 1.682-4.908 1.682-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8 0 1.858-0.633 3.567-1.695 4.925l0.013-0.018 5.35 5.33-1.42 1.42-5.33-5.34zM8 14c3.314 0 6-2.686 6-6s-2.686-6-6-6v0c-3.314 0-6 2.686-6 6s2.686 6 6 6v0z"></path>
        </svg>

        <input type="text" placeholder="Search by keyword" @input="refine($event.target.value)">
    </div>
</template>

<script>
import query from '../../searchy/query';

export default {
    data() {
        return {
            query: null,
            refine: null
        };
    },

    created() {
        const { refine, active } = query(['title', 'summary']);
        this.refine = refine;
        this.query  = active;
    }
};
</script>

<style lang="scss" scoped>
    .root {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        height: 46px;
        padding: 0 1.5em;
        border: 1px solid #DDDDDD;
        border-radius: 999px;
    }

    svg {
        margin-right: 1em;
        color: #EF6E0B;
        fill: currentColor;
    }

    input {
        flex: 1;
        appearance: none;
        border: 0;
        font-family: inherit;
        font-size: 1em;

        &::placeholder {
            color: #AFAFAF;
        }

        &:focus {
            outline: none;
        }
    }
</style>